import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-add-member-wrapper-modal',
  templateUrl: './add-member-wrapper-modal.component.html',
  styleUrls: ['./add-member-wrapper-modal.component.css']
})
export class AddMemberWrapperModalComponent implements OnInit {
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();
  @Input() memberId;


  constructor() { }

  ngOnInit() {
  }

  onSaveMember(evt) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
